import {
  CreateParams,
  DataProvider,
  DeleteOneParams,
  UpdateParams,
} from "@refinedev/core";
import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";

import axAPI from "../../../api/axios-instance";

const AWARD_TYPE_URL = "cms/awards/award";
const AWARD_TYPES_LIST_URL = "cms/awards/award/list";

type AwardTypeFormValues = {
  name?: string;
  displayName?: string;
  imageUrl?: string;
};

type AwardTypeMeta = {
  id?: number | string;
};

export const awardTypesDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    getApiUrl: () => apiUrl,
    getList: async () => {
      try {
        const { data } = await httpClient.get(AWARD_TYPES_LIST_URL);

        return {
          data,
          total: data.length,
        };
      } catch (error: unknown) {
        return Promise.reject(error);
      }
    },
    getOne: async ({ id }) => {
      try {
        const { data } = await httpClient.get(AWARD_TYPE_URL, {
          params: { id },
        });

        return {
          data: {
            ...data,
          },
        };
      } catch (error: unknown) {
        return Promise.reject(error);
      }
    },
    create: async ({ variables }: CreateParams<AwardTypeFormValues>) => {
      try {
        const { data } = await httpClient.post(AWARD_TYPE_URL, {
          name: variables.name,
          displayName: variables.displayName,
          imageUrl: variables.imageUrl,
        });

        return {
          data: {
            ...variables,
            result: data,
          },
        };
      } catch (error: unknown) {
        return Promise.reject(error);
      }
    },
    update: async ({ id, variables }: UpdateParams<AwardTypeFormValues>) => {
      try {
        const { data } = await httpClient.put(AWARD_TYPE_URL, {
          id: Number(id),
          name: variables.name,
          displayName: variables.displayName,
          imageUrl: variables.imageUrl,
        });

        return {
          data: {
            id,
            ...variables,
            result: data,
          },
        };
      } catch (error: unknown) {
        return Promise.reject(error);
      }
    },
    deleteOne: async ({ id, meta }: DeleteOneParams) => {
      const awardTypeId = (meta as AwardTypeMeta | undefined)?.id ?? id;

      try {
        const { data } = await httpClient.delete(AWARD_TYPE_URL, {
          params: { id: Number(awardTypeId) },
        });

        return {
          data: {
            id: awardTypeId,
            result: data,
          },
        };
      } catch (error: unknown) {
        return Promise.reject(error);
      }
    },
  };
